module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/saas-sketch-2-f03b4929b215d3d662446369fcc6606f.svg";